import type { Secret as SecretModel } from '@/adapters/catalogv1.g';

export function extractSecret(model: SecretModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.secret_ref ?? '',
    name: model.name ?? '',
    provider: model.provider,
    path: model.path,
    type: model.type,
    createdAt: model.created_at ? new Date(model.created_at) : undefined,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogSecret = ReturnType<typeof extractSecret>;
